export default "__VITE_ASSET__egyOpZ_2__"